import { isMobile } from 'react-device-detect';
import photo from './photo.json';

const API_REST_URL = process.env.REACT_APP_ENV_URL_BACKEND;
const DATASOURCE_ENV = process.env.REACT_APP_DATASOURCE_ENV;
const AUTH_TOKEN = 'AUTH_TOKEN';
const REFRESH_TOKEN = 'REFRESH_TOKEN';
const GRAPHQL_URL = process.env.REACT_APP_GRAPHQL_URL;
const MIL_PERU = 5 * 1000 * 60 * 60;
const CAREER = { PREG: 'PREG', CGT: 'PPE' };
const URL_MAPS = 'https://maps.google.com/maps?q=';
const PE_URL = process.env.REACT_APP_PE_URL as string;
const PE_URL_2 = process.env.REACT_APP_PE_URL_2 as string;
const PE_PATH_COURSES = process.env.REACT_APP_PE_PATH_COURSES;
const PE_PATH_PAYMENTS = process.env.REACT_APP_PE_PATH_PAYMENTS;
const PE_PATH_RESERVE_RESOURCES =
  process.env.REACT_APP_PE_PATH_RESERVE_RESOURCES;
const PE_PATH_ADVANCE_CURRICULUM =
  process.env.REACT_APP_PE_PATH_ADVANCE_CURRICULUM;
const PE_PATH_INSTITUTIONAL_INFORMATION =
  process.env.REACT_APP_PE_PATH_INSTITUTIONAL_INFORMATION;
const PE_PATH_NOTES_RECORD = process.env.REACT_APP_PE_PATH_NOTES_RECORD;
const PE_PATH_PROGRESSIVE_CERTIFICATIONS =
  process.env.REACT_APP_PE_PATH_PROGRESSIVE_CERTIFICATIONS;
const PE_PATH_REINFORCEMENTS = process.env.REACT_APP_PE_PATH_REINFORCEMENTS;
const PE_PATH_RECTIFICACIONES = process.env.REACT_APP_PE_PATH_RECTIFICACIONES;
const PE_PATH_TRAMITES2 = process.env.REACT_APP_PE_PATH_TRAMITES2;
const PE_PATH_CARGA_PAGO = process.env.REACT_APP_PE_PATH_CARGA_PAGO;
const PE_PATH_ROL_EXAMENES = process.env.REACT_APP_PE_PATH_ROL_EXAMENES;
const PE_PATH_TURNO_HORARIO_MATRICULA =
  process.env.REACT_APP_PE_PATH_TURNO_HORARIO_MATRICULA;
const PE_PATH_CATALOGO_CURSOS = process.env.REACT_APP_PE_PATH_CATALOGO_CURSOS;
const PE_PATH_ENCUESTA_INTENCION_MATRICULA =
  process.env.REACT_APP_PE_PATH_ENCUESTA_INTENCION_MATRICULA;
const PE_PATH_HISTORICO_TRAMITES =
  process.env.REACT_APP_PE_PATH_HISTORICO_TRAMITES;
const PE_PATH_IMPRIMIR = process.env.REACT_APP_PE_PATH_IMPRIMIR;
const CLASS_TYPE = {
  faceToFaceTheoretical: '1',
  faceToFacePractical: '2',
  virtualTheoretical: '3',
  virtualPractical: '4',
  remoteTheoretical: '5',
  remotePractical: '6'
};

const CARD_TYPES = {
  CURSO_REMOTO: 'C',
  CURSO_PRESENCIAL: 'P',
  CURSO_VIRTUAL: 'V',
  ACTIVIDAD: 'A',
  EXAMEN: 'E',
  REFORZAMIENTO: 'R'
};

const INSTRUCTION_MODES = {
  REMOTO: 'R',
  PRESENCIAL: 'P',
  SEMI_PRESENCIAL: 'SP',
  VIRTUAL: 'VT'
};

const SCREEN_SIZE = {
  sm: 640,
  md: 768,
  lg: 992,
  xl: 1280
};

const PIXELS_PER_MIN_DSK = 1.3333;
const PIXELS_PER_MIN_MOB = 1.6666;

const BREAKPOINT_SIZE = SCREEN_SIZE.lg;

const keycloakConfig = {
  realm: process.env.REACT_APP_KEYCLOAK_REALM as string,
  url: process.env.REACT_APP_KEYCLOAK_URL_AUTH,
  clientId: 'utpmas-web'
};

const roles = ['simulator', 'student', 'visor'];

export default {
  ROLES: roles,
  API_REST_URL: `${API_REST_URL}`,
  GRAPHQL_URL,
  AUTH_TOKEN,
  REFRESH_TOKEN,
  MIL_PERU,
  CAREER,
  CLASS_TYPE,
  DATASOURCE_ENV,
  SCREEN_SIZE,
  BREAKPOINT_SIZE,
  PIXELS_PER_MIN: isMobile ? PIXELS_PER_MIN_MOB : PIXELS_PER_MIN_DSK,
  KEYCLOAK: keycloakConfig,
  CARD_TYPES,
  INSTRUCTION_MODES,
  URL_MAPS,
  DEFAULT_PHOTO: photo.photo,
  PE_PATH_ADVANCE_CURRICULUM,
  PE_PATH_COURSES,
  PE_PATH_INSTITUTIONAL_INFORMATION,
  PE_PATH_NOTES_RECORD,
  PE_PATH_PAYMENTS,
  PE_PATH_PROGRESSIVE_CERTIFICATIONS,
  PE_PATH_RESERVE_RESOURCES,
  PE_PATH_REINFORCEMENTS,
  PE_PATH_RECTIFICACIONES,
  PE_PATH_TRAMITES2,
  PE_PATH_CARGA_PAGO,
  PE_PATH_ROL_EXAMENES,
  PE_PATH_TURNO_HORARIO_MATRICULA,
  PE_PATH_CATALOGO_CURSOS,
  PE_PATH_ENCUESTA_INTENCION_MATRICULA,
  PE_PATH_HISTORICO_TRAMITES,
  PE_PATH_IMPRIMIR,
  PE_URL,
  PE_URL_2,
  URL_INFO: process.env.REACT_APP_URL_INFO,
  URL_SURVEY:
    process.env.REACT_APP_SURVEY_URL ||
    'https://encuestas.utp.edu.pe/DefaultUTP.aspx',
  NEW_LOCATIONS: ['IQUIT', 'TACNA', 'PLLPA']
};
